import axios from "../utils/axios";

export function GetTicketStepTypeUserMappings() {
  return axios.get(`/TicketStepTypeUserMapping/GetTicketStepTypeUserMappings`);
}


export function MapOrUpdateUserToTicketStepType(userId, ticketStepTypeId, propertyType) {
  return axios.post(`/TicketStepTypeUserMapping/MapOrUpdateUserToTicketStepType?userId=${userId}&ticketStepTypeId=${ticketStepTypeId}&propertyType=${propertyType}`, {});
}